// extracted by mini-css-extract-plugin
module.exports = {"vGray10":"#cfd4dd","vLoadingOpacity":".6","share":"Share_share__32mSF","item":"Share_item__1Tnds","item_default":"Share_item_default__2bC8Y"};